import { createConfirmation } from "react-confirm";
import ConfirmDlgWidget from "./ConfirmDlgWidget";

export const showConfirmDlgWidget = createConfirmation(ConfirmDlgWidget);
